import { Log } from 'ng2-logger';
import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import { Common } from '../../../../core/common';
import { IAction, IAppState } from '../../../../models/action/core';
import { IActivityCard, IActivityCardItems } from '../../../../models/components/activity-card';
import { IProcessingActivity } from '../../../../models/components/processing-activity';
import { CourseContentMenuType } from '../../../../models/enums/CourseContentMenuType';
import { UserType } from '../../../../models/pages/login.d';
import * as Action from '../../../../store/actions/core';
import * as Actions from '../../../../store/actions/coursePage';
import * as ReportAction from '../../../../store/actions/reports';
import { Confirm } from '../../../notification/main';
import ReportModal from '../report/activity-report-modal';
import GradeModal from '../assignment/grade-modal';
import Translator from '../../../../core/i18n';
import { withRouter } from 'react-router-dom';
import * as EnrollmentActions from '../../../../store/actions/enrollment';
import * as CoreActions from '../../../../store/actions/core';
import * as IFrameActions from '../../../../store/actions/iFrameSource';
import { th } from 'date-fns/locale';
import { CoursePageService } from '../../../../api/course-page-service';
import { number } from 'yup';
import CustomIframeModal from '../../../iframe/iframe-modal';
import { ActivityType } from '../../../../models/enums/ActivityType';
import { SecurityContextType, SecurityPermissionType } from '../../../../core/SecurityContext';
import { MessageToIncompleters } from '../../../../store/actions/background';

const T = Translator.create();
const _logger = Log.create('Processing Activity');
let _common: Common;
let num = 0;
const coursePageService = new CoursePageService();
let statusText = '';
class ProcessingActivity extends React.Component<IProcessingActivity, any> {
    state = {
        redirectUrl: '/',
        isReportModalOpen: false,
        isGradeModalOpen: false,
        showExamIframeModalOpen: false,
        isReportGradeIframeModalOpen: false,
        activityCardItem: '',
        itemStatus: 0,
        isLoading: false,
        isPassive: false,
        usersAuthorizedToEdit: [
            UserType.Admin,
            UserType.ProgramAdmin,
            UserType.Teacher
        ],
        nonWeeklyCourse: this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length === 1
    };
    delayTimer: any;
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    triggerAddModal = () => {
        this.setState({
            ...this.state,
            isReportModalOpen: !this.state.isReportModalOpen
        });
    };
    public componentDidMount(): void {
        if (this.props.activityCardItems) {
            this.props.activityCardItems.forEach(index => {
                if (index.activeStatus === 1) {
                    this.setState({ itemStatus: index.activeStatus });
                }
            });
        }

        if (this.props.courseContentTermWeeks?.length === 1) {
            this.setState({ nonWeeklyCourse: true });
        }
    }


    componentDidUpdate(prevProps: Readonly<IProcessingActivity>, prevState: Readonly<any>, snapshot?: any): void {
        if (this.props.courseContentTermWeeks !== prevProps.courseContentTermWeeks && this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length === 1) {
            this.setState({ nonWeeklyCourse: true })
        }
    }

    triggerActivityReportModal = () => {
        let model = {
            ActivityId: this.props.activityId,
            ClassId: this.props.coursePageClassId,
            ReturnUrl: '/Activity/Report/{0}?classId={1}'
        }
        this.props.dispatch(IFrameActions.getIFrameSource(model));

        this.setState({
            ...this.state,
            showExamIframeModalOpen: !this.state.showExamIframeModalOpen
        });

        // this.props.dispatch(ReportAction.getRedirectToAlmsActivityAndExamReportUrlAction('activityReport', this.props.activityId, this.props.coursePageClassId, 'getRedirectToAlmsActivityAndExamReportUrl', 'get'));
    };

    triggerExamReportModal = () => {
        let model = {
            ActivityId: this.props.activityId,
            ClassId: this.props.coursePageClassId,
            ReturnUrl: '/Exam/Report/{0}?classId={1}'
        }
        this.props.dispatch(IFrameActions.getIFrameSource(model));

        this.setState({
            ...this.state,
            isReportGradeIframeModalOpen: !this.state.isReportGradeIframeModalOpen
        });

        // this.props.dispatch(ReportAction.getRedirectToAlmsActivityAndExamReportUrlAction('examReport', this.props.activityId, this.props.coursePageClassId, 'getRedirectToAlmsActivityAndExamReportUrl', 'get'));
    };

    triggerGradeModal = () => {
        this.setState({
            ...this.state,
            isGradeModalOpen: !this.state.isGradeModalOpen
        });
    };

    confirmText = () => {
        const selectedActivity = this.props.activityCardItems!.find(x => x.activityId === this.props.activityId!)

        if (selectedActivity!.isActivityPrerequisite && selectedActivity!.activityPrerequisiteCount && selectedActivity!.activityPrerequisiteCount > 0) {
            if (selectedActivity!.activityPrerequisiteCount > 1) {
                return T.t('r_delete_activity_information_multi_prerequsite_activity').replace('{0}', selectedActivity!.activityPrerequisiteCount).concat(" ", T.t('r_delete_activity_question'))
            }
            else {
                return T.t('r_delete_activity_information_prerequsite_activity').replace('{0}', selectedActivity!.activityNameBoundWithPrerequisite).concat(" ", T.t('r_delete_activity_question'))

            }
        }
        else {
            return ''
        }
    }

    confirmTitle = () => {
        const selectedActivity = this.props.activityCardItems!.find(x => x.activityId === this.props.activityId!)
        if (selectedActivity!.isActivityPrerequisite && selectedActivity!.activityPrerequisiteCount && selectedActivity!.activityPrerequisiteCount > 0) {
            return T.t('r_prerequisite_text')
        }
        else {

            if(this.props.activityType == ActivityType.Survey)
            {
                const returnActivity =this.props.activityCardItems?.filter(f => f.activityId === this.props.activityId)[0];
                if(returnActivity)
                {
                    if(returnActivity.surveyInfo.isResponded)
                    {
                            return T.t('r_delete_activity_question_survey');
                    }
                }
            }
            return T.t('r_delete_activity_question')
        }
    }

    public deleteActivityOnClick = () => {
        Confirm.setConfirm('normal', this.deleteActivityConfirmClick, this.confirmTitle(), this.confirmText(), null);
    };

    deleteActivityConfirmClick = () => {
        const menuItemActivities = this.props.courseContentWeekActivities;
        let afterDeletedActivityIndex = 0;
        if (
            this.props.courseContentWeekActivities &&
            this.props.courseContentWeekActivities.length > 0 &&
            (this.props.courseContentMenuType === CourseContentMenuType.weekAndActivity ||
                this.props.courseContentMenuType === CourseContentMenuType.weekAndActivityStory)
        ) {
            const deletedActivityMenuItem = this.props.courseContentWeekActivities.find(x => x.activityId === this.props.activityId);
            if (deletedActivityMenuItem && menuItemActivities) {
                const deletedActivityIndex = this.props.courseContentWeekActivities.indexOf(deletedActivityMenuItem);
                if (deletedActivityIndex !== 0) {
                    afterDeletedActivityIndex = deletedActivityIndex - 1;
                }
                menuItemActivities.splice(deletedActivityIndex, 1);
            }
        }

        const selectedActivity = this.props.activityCardItems!.find(x => x.activityId === this.props.activityId!)
        this.props.dispatch(
            Actions.getDeleteActivityAction(
                this.props.courseContentMenuType!,
                this.props.coursePageClassId!,
                this.props.coursePageActivityId!,
                this.props.activityId!,
                this.props.activityType!,
                this.returnActivityCard(this.props.activityCardItems!),
                menuItemActivities,
                'getDeleteActivityAction',
                'get',
                () => this.deleteCallback(selectedActivity),
                this.props.projectActivityId,
                afterDeletedActivityIndex
            )
        );
    };

    deleteCallback = (activity: any) => {
        if (activity) {
            if (this.props.courseContentMenuType === CourseContentMenuType.weekAndActivityStory && activity.activityId) {
                this.props.dispatch(Actions.setActId(activity.activityId));
            } else {
                const take = 200;
                const skip = 0;
                const spinnerId = 'spinnerIdWeekA';
                const spinnerType = 'get';

                // this.props.dispatch(
                //     Actions.getCourseContentsActivityCardAction(
                //         GetActivitiesType.Activity,
                //         this.props.coursePageClassId!,
                //         this.props.coursePageActivityId!,
                //         activity.activityId,
                //         activity.termWeekId,
                //         take,
                //         skip,
                //         spinnerId,
                //         spinnerType
                //     )
                // );

                // if (!this.props.projectActivityId) {
                //     this.props.dispatch(Actions.getCourseContentMenu(this.props.coursePageClassId!, false, 'getCourseContentMenu', 'get'));
                // }
            }
            if (activity!.isActivityPrerequisite && activity!.activityPrerequisiteCount && activity!.activityPrerequisiteCount > 0) {
                this.props.dispatch(Actions.setTriggerRemovePrerequisite(this.props.coursePageActivityId!, this.props.coursePageClassId!, activity!.activityPrerequisiteIds!, 'setTriggerRemovePrerequisite', 'set'));
            }
            this.props.dispatch(Actions.getActivityIdsByWeeks(this.props.coursePageClassId!, '', false, 'getActivityIdsByWeeks', 'get', undefined, false, this.props.coursePageActivityId ?? ""))


        } else {
            this.state.redirectUrl =
                'course?classId=' + this.props.coursePageClassId + '&activityId=' + this.props.coursePageActivityId + '&type=1';
            this.props.history.push(this.state.redirectUrl);
        }
    };

    public getActivitiesCallback = () => {
        this.props.dispatch(Actions.getActivityIdsByWeeks(this.props.coursePageClassId!, '', false, 'getActivityIdsByWeeks', 'get', undefined, false, this.props.coursePageActivityId ?? ""))
    }

    public returnActivityCard = (activityCardList: IActivityCardItems[]): IActivityCardItems[] => {
        const activityCards = activityCardList;
        const deletedActivity = activityCardList.find(x => x.activityId === this.props.activityId);
        if (deletedActivity) {
            const deletedActivityIndex = this.props.activityCardItems!.indexOf(deletedActivity);
            activityCards.splice(deletedActivityIndex, 1);
        }
        return activityCards;
    };

    public setActivityStatusCallBack = () => {
        coursePageService.RequestClearCourseCacheData({
            ClassId: this.props.coursePageClassId ? this.props.coursePageClassId : '0',
            CourseId: this.props.coursePageActivityId ? this.props.coursePageActivityId : '0'
        });
        this.props.dispatch(EnrollmentActions.enrollmentGetAction(this.props.coursePageClassId ? this.props.coursePageClassId : '0'));

        this.setState({ isLoading: true });
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => {
            this.setState({ isLoading: false });
            const param: IActivityCard = {
                actId: '',
                coursePageClassId: this.props.coursePageClassId,
                coursePageActivityId: this.props.coursePageActivityId,
                courseContentTermWeeks: this.props.courseContentTermWeeks,
                hasFilter: false,
                activityFilters: undefined,
                GetOnlyPassiveList: false,
                weekOrUnitId: this.props.weekOrUnitId,
                courseContentMenuType: this.props.courseContentMenuType,
                courseContentWeekActivities: this.props.activityCardItems,
                sort: this.props.sortKey ?? '-'
            };
            this.props.dispatch(Actions.SetTriggerGetActivities(param, this.getActivitiesCallback, "SetTriggerGetActivities", 'get', this.props.courseDefaultView, this.state.nonWeeklyCourse));
        }, 2000)
    }

    public SetActivityStatus(status: number) {
        this.props.dispatch(Actions.getActivityStatusSetAction(this.props.activityId!, status, "getActivityStatusSetAction", this.setActivityStatusCallBack));
        this.props.activityCardItems && this.props.activityCardItems.map((item) => {
            if (item.activeStatus == 1) {
                item.activeStatus = 0;
            }

        })
    }
    public findActivityStatus(actid: string) {
        let passiveControl = false
        this.props.activityCardItems && this.props.activityCardItems!.length > 0 &&
            this.props.activityCardItems.map((item) => {
                if (item.activityId === actid) {
                    if (item.activeStatus === 1) {
                        passiveControl = true
                        statusText = T.t('r_activity_processing_passive'); return { statusText, passiveControl }
                    } else {
                        passiveControl = false
                        statusText = T.t('r_activity_processing_active');
                        return { statusText, passiveControl }
                    }
                }
            })
        return passiveControl

    }
    public onClickItems(val: string) {
        switch (val) {
            case 'Edit': {
                this.props.dispatch(Action.activityTypeSetAction(this.props.activityType!, this.props.activityId!));
                break;
            }
            case 'Report': {
                this.triggerAddModal();
                break;
            }
            case 'ActivityReport': {
                this.triggerActivityReportModal();
                break;
            }
            case 'ExamReport': {
                this.triggerExamReportModal();
                break;
            }
            case 'Note': {
                this.triggerGradeModal();
                break;
            }
            default:
                break;
        }
    }

    public annoucementTabSelect = (value: any) => {

        this.props.dispatch(MessageToIncompleters(value))
    }

    public noneCompletersCheck = (actId?: string, activityType?: string): boolean => {

        if (activityType === 'InformationNote') {
            return false;
        }

        if (!actId || !this.props.activityCardItems) {
            return false;
        }

        const activity = this.props.activityCardItems.find(item => item.activityId === actId);

        if (!activity) {
            return false;
        }

        const { completedUser, totalEnrollUser } = activity;

        return completedUser !== totalEnrollUser;
    }

    public render() {
        return (this.props.userType && this.state.usersAuthorizedToEdit.includes(this.props.userType)) || this.props.isProjectSubActivity ? (
            <React.Fragment>
                <div className={'dropdown ml-2 ' + this.props.externalCssClassName ? this.props.externalCssClassName : ''}>
                    <a data-toggle="dropdown" href="javascript:;" aria-expanded="false">
                        <img src={_common.GetDefaultIcons('dots')} alt="Dots" />
                    </a>
                    <div
                        className="dropdown-menu shadow"
                        aria-labelledby="dropdownMenuButton"
                        x-placement="bottom-start"
                        style={{
                            position: 'absolute',
                            transform: ' translate3d(-165px, 22px, 0px); top: 0px; left: 0px; will-change: transform'
                        }}
                    >
                        {(this.props.isProjectSubActivity || (this.props.userType && this.state.usersAuthorizedToEdit.includes(this.props.userType))) && (
                            <a className={`dropdown-item ${this.props.activityType === "Exam" ? 'mobile-activity-edit' : ''}`}
                            tabIndex={0}
                            onClick={this.onClickItems.bind(this, 'Edit')}
                            onKeyDown={event => {
                                if (event.key === 'Enter') {
                                    this.onClickItems('Edit')                                   }
                            }}
                            >
                                {T.t('r_fileUpload_edit')}
                            </a>
                        )}
                        {(this.props.userType && this.state.usersAuthorizedToEdit.includes(this.props.userType) && this.props.activityType != 'InformationNote') && (
                            <a className="dropdown-item"
                            tabIndex={0}
                            onClick={this.onClickItems.bind(this, 'Report')}
                            onKeyDown={event => {
                                if (event.key === 'Enter') {
                                    this.onClickItems('Report')                                   }
                            }}
                            >
                              {T.t('r_activity_processing_view_report')}
                            </a>
                        )}
                        {(this.props.activityType === 'Exam' && this.props.userType && this.state.usersAuthorizedToEdit.includes(this.props.userType)) && (
                            <a className="dropdown-item"
                            tabIndex={0}
                            onClick={this.onClickItems.bind(this, 'ActivityReport')}
                            onKeyDown={event => {
                                if (event.key === 'Enter') {
                                    this.onClickItems('ActivityReport')                                   }
                            }}
                            >
                                {T.t('r_activity_processing_exam_report')}
                            </a>
                        )}
                        {(this.props.activityType === 'Exam' && this.props.userType && this.state.usersAuthorizedToEdit.includes(this.props.userType)) && (
                            <a className="dropdown-item"
                            tabIndex={0}
                            onClick={this.onClickItems.bind(this, 'ExamReport')}
                            onKeyDown={event => {
                                if (event.key === 'Enter') {
                                    this.onClickItems('ExamReport')                                   }
                            }}
                            >
                                {T.t('r_activity_processing_exam_report_and_grading')}
                            </a>
                        )}

                        {this.noneCompletersCheck(this.props.activityId, this.props.activityType) && (
                            <a className="dropdown-item"
                                tabIndex={0}
                                onClick={() => this.annoucementTabSelect(this.props.activityId)}
                                onKeyDown={event => {
                                    if (event.key === 'Enter') {
                                        this.annoucementTabSelect(this.props.activityId)
                                    }
                                }}
                            >
                                {T.t('r_announcement_to_non_completers')}
                            </a>
                        )
                        }


                        {this.props.activityType === 'Assignment' && this.props.userType && this.state.usersAuthorizedToEdit.includes(this.props.userType) && (
                            <a className="dropdown-item"
                            tabIndex={0}
                            onClick={this.onClickItems.bind(this, 'Note')}
                            onKeyDown={event => {
                                if (event.key === 'Enter') {
                                    this.onClickItems('Note')                                   }
                            }}
                            >
                                {T.t('r_activity_processing_grade')}
                            </a>
                        )}
                        {/*----------------------------------------------------------------------*/}
                        {this.props.activityType !== 'Exam' ?
                            (this.props.userType && this.state.usersAuthorizedToEdit.includes(this.props.userType)) && (
                                <>
                                    {this.findActivityStatus(this.props.activityId!) ? (
                                        <>
                                            <a
                                                className="dropdown-item"
                                                onClick={() => {
                                                    this.SetActivityStatus(0);
                                                }}
                                                tabIndex={0}
                                                onKeyDown={event => {
                                                    if (event.key === 'Enter') {
                                                        this.SetActivityStatus(0);                                }
                                                }}
                                            >
                                                {statusText}
                                            </a>
                                        </>
                                    ) : (
                                        <>
                                            <a className="dropdown-item" onClick={() => this.SetActivityStatus(1)}
                                            tabIndex={0}
                                            onKeyDown={event => {
                                                if (event.key === 'Enter') {
                                                    this.SetActivityStatus(1);                                }
                                            }}
                                                >
                                                {statusText}
                                            </a>
                                        </>
                                    )}
                                </>
                            )
                            : null}
                        {/*----------------------------------------------------------------------*/}
                        {((this.props.userType && this.state.usersAuthorizedToEdit.includes(this.props.userType)) || this.props.isProjectSubActivity) && (
                            <>
                                <div className="dropdown-divider" />
                                <p
                                    className="dropdown-item text-danger mb-1"
                                    style={{ cursor: 'pointer', paddingTop: 4 + 'px !important' }}
                                    onClick={this.deleteActivityOnClick}
                                    tabIndex={0}
                                    onKeyDown={event => {
                                        if (event.key === 'Enter') {
                                            this.deleteActivityOnClick()                                      }
                                    }}
                                >
                                    {T.t('r_activity_processing_delete_activity')}
                                </p>
                            </>
                        )}
                    </div>
                </div>
                {this.state.isReportModalOpen ? (
                    <ReportModal
                        activityId={this.props.activityId!}
                        modalIsOpen={this.state.isReportModalOpen}
                        onClose={this.triggerAddModal}
                    />
                ) : null}
                {this.state.isGradeModalOpen ? (
                    <GradeModal
                        isProjectSubActivity={this.props.isProjectSubActivity!}
                        activityId={this.props.activityId!}
                        modalIsOpen={this.state.isGradeModalOpen}
                        onClose={this.triggerGradeModal}
                    />
                ) : null}
                {this.state.showExamIframeModalOpen ? (
                    <CustomIframeModal
                        onClose={this.triggerActivityReportModal}
                        id='examReport'
                        name='examReport'
                        modalName={T.t('r_menu_exam_statistics')}
                        src={this.props.iFrameSource}
                    />
                ) : null}
                {this.state.isReportGradeIframeModalOpen ? (
                    <CustomIframeModal
                        onClose={this.triggerExamReportModal}
                        id='examGradeReport'
                        name='examGradeReport'
                        modalName={T.t('r_menu_exam_statistics')}
                        src={this.props.iFrameSource}
                    />
                ) : null}
            </React.Fragment>
        ) : (
            ''
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IProcessingActivity): IProcessingActivity => {
    if (!state) {
        return ownProps;
    }

    const newProps: IProcessingActivity = Object.assign({}, ownProps, {
        identity: state.login.identitiy,
        userType: state.login.identitiy.userType,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        coursePageClassId: state.coursePage.coursePageClassId,
        weekOrUnitId: state.coursePage.weekOrUnitId,
        courseContentWeekActivities: state.coursePage.courseContentWeekActivities,
        courseContentTermWeeks: state.coursePage.courseContentTermWeeks,
        courseContentMenuType: state.coursePage.courseContentMenuType,
        activityCardItems: state.coursePage.activityCard,
        iFrameSource: state.iFrame.iFrameSource,
        courseDefaultView: state.coursePage.courseDefaultView,
        sortKey: state.coursePage.courseSortingKey
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};
const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.coursePage.activityCard === prev.coursePage.activityCard &&
        next.iFrame.iFrameSource === prev.iFrame.iFrameSource &&
        next.coursePage.courseContentTermWeeks === prev.coursePage.courseContentTermWeeks &&
        next.coursePage.courseDefaultView === prev.coursePage.courseDefaultView &&
        next.coursePage.courseSortingKey === prev.coursePage.courseSortingKey;
    return ret;
};
const CProcessingActivity = connect(mapStateToProps, dispatchProps, null, { areStatesEqual })(ProcessingActivity);

export default withRouter<any, any>(CProcessingActivity);
